import React, { useState, useEffect } from 'react';

import profilePic from '../../images/profile-placeholder.jpg';

export default function MessageList(props) {
    const [user, setUser] = useState();
    useEffect(() => {
        // the user that loged in now
        const userAuth = JSON.parse(localStorage.getItem('jwt'))?.user;
        // in case the user is a company
        if (props.messageDetails && userAuth.company) {
            //show the data of user in chat
            setUser(props.messageDetails.user)
        }
        else {
            setUser(props.messageDetails.company)
        }
    }, []);
    if (!user) {
        return (<div>loading...</div>)
    }
    else {
        return (
            <section key={props.messageDetails.id} className=" border-bottom pt-2 pb-2 ">
                <button onClick={e => props.handleMessageClick(props.messageDetails.id)} className="border-0 bg-transparent row m-0 justify-content-center align-items-center text-left w-100">
                    <figure className="mb-0 col-3 ">
                        {/* profile img for web */}
                        <img alt="user" height="61px" width="61px" src={user?.profile_image?.url || user.logo?.url || profilePic} className="rounded-circle d-web p-relative" />
                        {/* <div header="25px" width="25px" className="bg-orange p-absolute rounded-circle text-center d-web" style={{top : '0' , right : '1px' , height:'25px',width : '25px'}}>
                            <p className="text-white">1</p>
                        </div> */}
                        {/* profile img for mobile */}
                        <img alt="user" height="51px" width="51px" src={user?.profile_image?.url || user.logo?.url || profilePic} className="rounded-circle d-mob p-relative" />
                        {props.messageDetails.CountUnReadMessages ?
                            <div className="bg-orange p-absolute rounded-circle text-center" style={{ top: '-3px', left: '5px', height: '25px', width: '25px' }}>
                                <p style={{ fontSize: '11px' }} className="text-white pt-1 pb-1">{props.messageDetails.CountUnReadMessages}</p>
                            </div> : ''
                        }
                    </figure>
                    <article className="col-9 pl-0">
                        <header className="row m-0">
                            {/* for web */}
                            <p style={{ fontSize: '14px' }} className="col-7 pl-0 text-orange mb-0 d-web ">{user?.name}</p>
                            <p style={{ fontSize: '11px' }} className="col-5 p-0 text-grey mb-0 text-right d-web ">{new Date(props.messageDetails.messages.data[0].created_at).toDateString()}</p>
                            {/* for mobile */}
                            <p style={{ fontSize: '11px' }} className="col-7 pl-0 text-orange mb-0 d-mob ">{user?.name}</p>
                            <p style={{ fontSize: '9px' }} className="col-5 p-0 text-grey mb-0 text-right d-mob">{new Date(props.messageDetails.messages.data[0].created_at).toDateString()}</p>
                        </header>
                        <p style={{ fontSize: '12px' }} className="text-grey mb-0">
                            {props.messageDetails.messages.data[0].text}
                        </p>
                    </article>
                </button>
            </section>
        )
    }
}